import React, { createContext, ReactNode, useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Outlet } from 'react-router-dom';

import { Box, Container, Typography } from '@mui/material';

import { Logo } from '../atoms/icons/logo';
import { Link } from '../atoms/link';
import { Row } from '../atoms/row';
import { Me } from '../modules/layout/me';
import { Nav } from '../modules/layout/nav';
import { PageWarningAlert } from '../modules/layout/page-warning-alert';

export const MainLayout = () => {
	const [warningAlertContent, setWarningAlertContent] = useState<ReactNode | null>(
		new Date() < new Date('2025-05-29') ? (
			<Typography
				variant="body2"
				sx={{
					'& a': {
						'color': 'inherit',
						'textDecoration': 'underline',
						'&:hover': { textDecoration: 'none' },
					},
				}}
			>
				<FormattedMessage
					id="mainLayout.energyTalk"
					defaultMessage="Připojte se 28.5.2025 na {link}"
					values={{
						link: (
							<a href="https://www.energytalk.cz" target="_blank">
								Infigy Energy Talk
							</a>
						),
					}}
				/>{' '}
			</Typography>
		) : null,
	);

	return (
		<mainLayoutContext.Provider value={{ warningAlertContent, setWarningAlertContent }}>
			{warningAlertContent && <PageWarningAlert>{warningAlertContent}</PageWarningAlert>}

			<Box component="main" sx={{ minHeight: '100vh', bgcolor: 'secondary.main', pt: { xs: 2, md: 7 } }}>
				<Container>
					<Row sx={{ justifyContent: 'space-between', alignItems: 'flex-start', mb: { xs: 1.5, md: 3 } }}>
						<Link to="/">
							<Row sx={{ gap: 0.5 }}>
								<Logo sx={{ fontSize: 24, color: 'primary.main' }} />
								<Typography
									variant="h4"
									component="span"
									sx={{ color: 'primary.main', textDecoration: 'none !important' }}
								>
									Infigy
								</Typography>
							</Row>
						</Link>

						<Nav />

						<Me sx={{ display: { xs: 'none', md: 'block' }, textAlign: 'right' }} />
					</Row>

					<Outlet />
				</Container>
			</Box>
		</mainLayoutContext.Provider>
	);
};

type MainLayoutContext = {
	warningAlertContent: ReactNode | null;
	setWarningAlertContent: (content: ReactNode | null) => void;
};

const mainLayoutContext = createContext<MainLayoutContext>({
	warningAlertContent: null,
	setWarningAlertContent: () => {},
});

export const useMainLayoutContext = () => useContext(mainLayoutContext);
